import { toast } from 'react-toastify';
import { type UseMutationResult, useMutation, useQueryClient } from 'react-query';
import ToastComponent from '../../components/toast';
import { BrandingPackageService } from '@wealthlane/api-services/wealthlane-identity-service';

interface UploadLogoPayload {
  File?: Blob;
  ImageLink?: string;
  RemoveOldLogo?: boolean;
  Favicon?: Blob;
  FaviconLink?: string;
  RemoveOldFavicon?: boolean;
  PageTitlePrefix?: string;
}

const usePostBrandingPackageLogo = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  onSuccess?: () => void
): UseMutationResult<boolean | undefined, unknown, UploadLogoPayload, unknown> => {
  const queryClient = useQueryClient();
  
  return useMutation(
    async (payload: UploadLogoPayload) => {
      const response = await handleRequest(
        BrandingPackageService.postApiIdentityApiBrandingPackageUploadLogo(payload as any)
      );
      return response?.isSuccess;
    },
    {
      onSuccess: async (response: any) => {
        if (response != null && response !== false) {
          // Invalidate both queries to refresh the branding everywhere
          await queryClient.invalidateQueries('getBrandingPackageDefault');
          await queryClient.invalidateQueries('getCurrentCompanyBrandingConfig');
          toast.success(<ToastComponent label='Success' message='Branding configuration updated successfully!' />);
          onSuccess?.();
        }
      },
      onError: (err) => {
        console.log('error', err);
      },
    }
  );
};

export default usePostBrandingPackageLogo;
